import React, { useState, useEffect } from "react";
import Logo from '../../assets/images/logoGiga2.png';
import QR from '../../assets/qdcode/QRCODE.png';
import Google from '../../assets/images/googleplay.png';
import AppleStore from '../../assets/images/AppStore.png';
import Privacidade from "../../pages/Politicas/Privacidade";
import CookiesPage from "../../pages/Politicas/CookiesPage";
import About from "../../pages/About/About";
import FooterModal from "./FooterModal";
import Tiktok from '../../assets/logos/icons8-tiktok-50.png';
import './footer.css';

const Footer = () => {
  const [showAboutModal, setShowAboutModal] = useState(false);
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);
  const [showCookiesModal, setShowCookiesModal] = useState(false);
  const [whatsAppLink, setWhatsAppLink] = useState("");

  const message = "Internet, TV por Assinatura, Telefonia Fixa, Internet Rural";

  useEffect(() => {
    const userAgent = navigator.userAgent.toLowerCase();
    const baseURL = "https://wa.me/556222000000";
    const messageParam = encodeURIComponent(`Olá, gostaria de falar sobre: ${message}`);
    if (/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/.test(userAgent)) {
      setWhatsAppLink(`whatsapp://send?phone=556222000000&text=${messageParam}`);
    } else {
      setWhatsAppLink(`${baseURL}?text=${messageParam}`);
    }
  }, []);

  return (
    <>
      <footer className="footer-wrapper">
        {/* Main Footer */}
        <div className="footer-main">
          <div className="container-fluid footer-container">
            <div className="row footer-row">

              {/* Coluna 1 - Empresa */}
              <div className="col-12 col-md-6 col-lg-4 footer-col">
                <h2 className="footer-brand-title">Gigabyte Telecom</h2>
                <div className="footer-divider"></div>
                <p className="footer-description">
                  A GigaByte Telecom é uma operadora de telecomunicações
                  que oferece soluções em Internet, Streaming de TV e Telefonia Fixa.
                </p>
                <p className="footer-cnpj">CNPJ: 08.664.106/0001-00</p>

                <p className="footer-app-label">Baixe nosso aplicativo:</p>
                <div className="footer-store-buttons">
                  <a href="https://play.google.com/store/apps/details?id=br.com.badbit.gigabytetelecom&hl=pt_BR" target="_blank" rel="noopener noreferrer" className="footer-store-link">
                    <img src={Google} alt="Google Play" className="footer-store-img" />
                  </a>
                  <a href="https://apps.apple.com/br/app/gigabyte-telecom-cliente/id1620548702" target="_blank" rel="noopener noreferrer" className="footer-store-link">
                    <img src={AppleStore} alt="App Store" className="footer-store-img" />
                  </a>
                </div>
                <div className="footer-left">
                  <div className="footer-qr">
                    <img src={QR} alt="QR Code" />
                  </div>
                  <div className="giguinha">
                    <img
                      src="https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/69a9cd3803003769df80c587/47e274a0e_giguinha.png"
                      alt="Giguinha"
                      className="footer-mascot-img"
                    />
                  </div>
                </div>
              </div>

              {/* Coluna 2 - Navegação */}
              <div className="col-12 col-md-6 col-lg-4 footer-col footer-col-nav">
                <h3 className="footer-col-title">Navegação</h3>
                <div className="footer-divider"></div>
                <ul className="footer-nav-list">
                  <li><a href="/">Página Inicial</a></li>
                  <li><a href="/internet">Planos Internet</a></li>
                  <li><a href="/internet-rural">Planos Internet Rural</a></li>
                  <li><a href="/streaming">Streaming de TV</a></li>
                  <li><a href="/telefone">Telefonia Fixa</a></li>
                  <li><a href="https://gigabytemultimidia.com.br/" target="_blank" rel="noopener noreferrer">Giga Multimídia</a></li>
                  <li><a href="/work">Trabalhe Conosco</a></li>
                  <li>
                    <button className="footer-text-btn" onClick={() => setShowAboutModal(true)}>
                      Quem Somos
                    </button>
                  </li>
                  <li>
                    <button className="footer-text-btn" onClick={() => setShowPrivacyModal(true)}>
                      Políticas de Privacidade
                    </button>
                  </li>
                  <li>
                    <button className="footer-text-btn" onClick={() => setShowCookiesModal(true)}>
                      Políticas de Cookies
                    </button>
                  </li>
                </ul>
              </div>

              {/* Coluna 3 - Contato */}
              <div className="col-12 col-md-12 col-lg-4 footer-col">
                <h3 className="footer-col-title">Entre em Contato</h3>
                <div className="footer-divider"></div>

                <div className="footer-contact-item">
                  <div className="footer-contact-icon">
                    <i className="fa fa-phone" aria-hidden="true"></i>
                  </div>
                  <div>
                    <a href="tel:06222000000" className="footer-contact-link">(62) 2200-0000</a>
                    <span className="footer-contact-sub"> | 0800 062 2200</span>
                  </div>
                </div>

                <div className="footer-contact-item">
                  <div className="footer-contact-icon">
                    <i className="fa fa-envelope" aria-hidden="true"></i>
                  </div>
                  <a href="mailto:faleconosco@gigabytetelecom.com.br" className="footer-contact-link footer-email">
                    faleconosco@gigabytetelecom.com.br
                  </a>
                </div>

                <h3 className="footer-col-title" style={{ marginTop: '24px' }}>Siga-nos</h3>
                <div className="footer-divider"></div>
                <div className="footer-social-icons">
                  <a href={whatsAppLink} target="_blank" rel="noopener noreferrer" className="footer-social-btn footer-social-whatsapp" aria-label="WhatsApp">
                    <i className="fa fa-whatsapp" aria-hidden="true"></i>
                  </a>
                  <a href="https://www.facebook.com/gigabytetelecom" target="_blank" rel="noopener noreferrer" className="footer-social-btn footer-social-facebook" aria-label="Facebook">
                    <i className="fa fa-facebook-official" aria-hidden="true"></i>
                  </a>
                  <a href="https://www.instagram.com/gigabytetelecom/" target="_blank" rel="noopener noreferrer" className="footer-social-btn footer-social-instagram" aria-label="Instagram">
                    <i className="fa fa-instagram" aria-hidden="true"></i>
                  </a>
                  <a href="https://www.tiktok.com/@gigabytetelecom_?_t=ZM-908XgMx5TS8&_r=1&fbclid=PAZXh0bgNhZW0CMTEAc3J0YwZhcHBfaWQMMjU2MjgxMDQwNTU4AAGnLnQLc76YyY731646F2o4wPVWOgMfylLq0mXoVeTR9sgqa7iMVO06prMAPZg_aem_8t8reH_tyYHNy5-wkuSNqg" target="_blank" rel="noopener noreferrer" className="footer-social-btn footer-social-instagram" aria-label="Instagram">
                    <img src={Tiktok} alt="" style={{width: '20px'}} />
                  </a>
                </div>

                <a href="/work" className="footer-work-btn">
                  <i className="fa fa-briefcase" aria-hidden="true" style={{ marginRight: '8px' }}></i>
                  Trabalhe Conosco
                </a>

              </div>

            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="footer-bottom">
          <div className="container-fluid">
            <div className="footer-bottom-inner">
              <div className="footer-bottom-logo">
                <img src={Logo} alt="Gigabyte Telecom" />
              </div>
              <p className="footer-copyright">
                © 2007 - {new Date().getFullYear()} — Gigabyte Telecom. Todos os direitos reservados.
              </p>
              <div className="footer-bottom-links">
                <button className="footer-bottom-btn" onClick={() => setShowPrivacyModal(true)}>
                  Privacidade
                </button>
                <span className="footer-bottom-sep">•</span>
                <button className="footer-bottom-btn" onClick={() => setShowCookiesModal(true)}>
                  Cookies
                </button>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {/* Modais */}
      <FooterModal
        show={showAboutModal}
        onHide={() => setShowAboutModal(false)}
        title="Conheça Nossa História"
      >
        <About />
      </FooterModal>

      <FooterModal
        show={showPrivacyModal}
        onHide={() => setShowPrivacyModal(false)}
        title="Política de Privacidade"
      >
        <Privacidade />
      </FooterModal>

      <FooterModal
        show={showCookiesModal}
        onHide={() => setShowCookiesModal(false)}
        title="Política de Cookies"
      >
        <CookiesPage />
      </FooterModal>
    </>
  );
};

export default Footer;